import { get } from '../../shared/api/http';

export interface HostEvent {
  id: string;
  name: string;
  tier: 'SEMANAL' | 'MENSUAL';
  status: 'SCHEDULED' | 'LIVE' | 'DONE' | 'CANCELLED';
  scheduledAt: string | null;
  assignedAt: string;
  isCurrent: boolean;
  drawsCount: number;
  prizesTotal: number;
}

export interface HostSummary {
  id: string;
  name: string;
  handle: string | null;
  email: string;
  active: boolean;
  expiresAt: string | null;
  lastLoginAt: string | null;
  createdAt: string;
  currentEvent: { id: string; name: string; tier: 'SEMANAL' | 'MENSUAL'; status: string; scheduledAt: string | null } | null;
  eventsHosted: number;
  drawsCount: number;
  prizesTotal: number;
}

export interface HostDetail extends HostSummary {
  events: HostEvent[];
  draws: { id: string; at: string; eventName: string; prizeName: string; prizeEmoji: string | null; prizeValue: number; number: string; playerName: string }[];
}

/** Influenciadores (leitura). Bloquear, senha e atribuição de sorteio usam `usersApi`. */
export const hostsApi = {
  list: (): Promise<HostSummary[]> => get('/hosts'),
  get: (id: string): Promise<HostDetail> => get(`/hosts/${id}`),
  /** A ficha do anfitrião logado (papel HOST). */
  me: (): Promise<HostDetail> => get('/hosts/me'),
};
